// External
import { createSlice } from "@reduxjs/toolkit";
// Action Constants
import {
	updateAnswer,
	updateInformation,
	initAnswers,
} from "../actions/answers";
// Initial State
const initialState = {
	answersReady: false,
};
// Answer Reducer
const answers = createSlice({
	name: "answers",
	initialState,
	reducers: {
		// This reducer is only used with internal action defined here
	},
	extraReducers: {
		// Used with external action which is defined in other directory
		[initAnswers.type]: (state, action) => {
			const questions = action.payload.questions;
			questions.forEach((question) => {
				let initAnswer = [];
				if (question.default_answer_id) {
					const defaultAnswer = question.answers.find(
						(answer) =>
							String(answer.id) ===
							String(question.default_answer_id),
					);
					if (defaultAnswer) {
						initAnswer = [defaultAnswer];
					}
				}
				state[question.id] = { answer: initAnswer, touched: false };
			});
			state.answersReady = true;
			return state;
		},
		[updateAnswer.type]: (state, action) => {
			const number = action.payload.question.id;
			const answer = action.payload.answer;

			state[number] = { answer, touched: true };

			return state;
		},
		[updateInformation.type]: (state, action) => {
			state["age"] = action.payload.age;
			state["email"] = action.payload.email;
			state["postcode"] = action.payload.postcode;
			state["liveInAustralia"] = action.payload.liveInAustralia;

			return state;
		},
	},
});
export default answers.reducer;
